import { render, staticRenderFns } from "./OptionGroupTemplates.vue?vue&type=template&id=13368ce3"
import script from "./OptionGroupTemplates.vue?vue&type=script&lang=js"
export * from "./OptionGroupTemplates.vue?vue&type=script&lang=js"
import style0 from "./OptionGroupTemplates.vue?vue&type=style&index=0&id=13368ce3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports